import React, { useState, useRef, useEffect } from "react";
import { Upload } from "@aws-sdk/lib-storage";
import { S3Client, S3 } from "@aws-sdk/client-s3";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { S3Config } from "./aws-config";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
// import { configure } from './../../../config';
import {
    LinearProgress,
    CircularProgress,
    Divider,
    Box,
    Button,
    Modal,
    Grid,
    MenuItem,
    Paper,
    Select,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DoneIcon from "@mui/icons-material/Done";
import FormControl from "@mui/material/FormControl";
import { format } from "date-fns";
import { width } from "@mui/system";
import ApiService from "./../../../ApiService";
import axios from "axios";
import { configure } from "./../../../config";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import moment from "moment";
import { json, useLocation, useNavigate } from "react-router-dom";

const StyledModal = styled(Modal)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

function CircularProgressWithLabel(props) {
    return (
        <Box sx={{ position: "relative", display: "inline-flex" }}>
            <CircularProgress variant="determinate" {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary">
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

const config = {
    headers: {
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,PUT,POST,OPTIONS,ANY",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Headers": "Origin, Content-Type, Accept, Authorization, X-Requested-With, privatekey",
        "Authorization": ""
    },
};

export default function MultiPart({
    fileList,
    uploadFileList,
    open,
    setOpen,
    isDashboard,
    experimentID,
    isView,
}) {

    const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");


    const fileDescriptionRef=useRef(null);
    const [fileDescription,setFileDescription]=useState("");

    const [progress, setProgress] = useState(0);
    const [isDisabled, setIsDisabled] = useState(true);
    const [userProfile, setUserProfile] = useState("");
    // const [getfiles, setFile] = useState(null);
    const [getList, setList] = useState([]);
    const [getUserList, setUserList] = useState([]);
    const [getCutomerList, setCutomerList] = useState([]);
    const [getBioRadList, setBioRadList] = useState([]);
    const user = JSON.parse(sessionStorage.getItem("userProfile"));
    const [isCompany, setCompany] = useState(false);
    const [companyName, setCompanyName] = useState(user.nickname);
    const [rowCompanyName, setRowCompanyName] = useState("Customer");
    const [email, setEmail] = useState("");
    const [inputValue, setValue] = useState("");
    const [isLoad, setLoad] = useState(true);
    var tempFileArray = [];
    var uploadFileArray = [];
    const [getfiles, setFile] = useState([]);
    const [isRefresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [getUploadList, setUploadList] = useState([]);
    const [Company_Name, setCompany_Name] = useState("");
    const { state } = useLocation();
    const [dashboadData, setDashboard] = useState(state);
    const [to, setTo] = useState("");
    const [formErrors, setFormErrors] = useState({
        email: "",

        Company_Name: "",
    });
    const [companyNames, setCompanyNames] = useState([]);
    const [selectedCompanyName, setSelectedCompanyName] = useState("");
    const [radioValue, setRadioValue] = useState("");
    console.log(radioValue, "radioValue");
    const handleRadioChange = (event) => {
        setRadioValue(event.target.value);
    };
    const [listedFiles, setlistedFiles] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadValue, setUploadValue] = useState(""); // Initialize uploadValue state
    const navigate = useNavigate();
    const [getUploadBioRadList, setGetBioRadList] = useState([]); // Initialize the array for cloud files

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };




    const handleUpload = async (val) => {
        if (!val) {
            return;
        }
        var user = JSON.parse(sessionStorage.getItem("userProfile"));
        var customerID = JSON.parse(sessionStorage.getItem("customerID"));
        var experiment_ID = JSON.parse(
            JSON.stringify(sessionStorage.getItem("experimentID"))
        );
        var path =
            customerID.username +
            "/" +
            experiment_ID + "/" + user.nickname ;
        const formData = {
            s3_bucket_path: path,
            file_name: val,
        };
        
        console.log(">>>>>>>>>", formData);
        const response = await fetch(`${configure.backendUrl}/copyfiles`, {
            method: 'POST',
            body: JSON.stringify(formData)
        });
        const responseData = await response.text();
        if (responseData && response.status === 200) {
            setSuccessMessage("File successfully moved to S3!");
            setOpenSuccessAlert(true);
            saveFile('Cloud');
        }
        else {
            setAlertMessage("Error moving file to S3. Please try again.");
            setOpenAlert(true);
        }
     
    };


    const handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setOpenAlert(false);
      };
     
      const handleCloseSuccessAlert = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setOpenSuccessAlert(false);
      };



 
// const handleSelectChange = (e) => {
//   const selectedValue = e.target.value;
//   console.log("Selected value:", selectedValue);
//   // Ensure that the selected value is not an empty object
//   setUploadValue(""); // Clear the uploadValue state
//   setTimeout(() => {
//     setUploadValue(selectedValue); // Set the selected value in the uploadValue state
//   }, 0);
//   handleUpload();
// };

    
    const handleSelectChange = (e) => {
        if (fileDescription !== "") {
            setUploadValue(e.target.value);
            const val = e.target.value;
            const cloudFile = {
                title: fileDescription,
                fileName: val
            }
            getCloudFile(cloudFile)
        }
        else {
            setAlertMessage("Enter File Description");
            setOpenAlert(true);
        }
    };

    const instruments=
            {
                "instrument_name":storedValue
            }

    const fetchData = async (model, bindData) => {
        try {
            const custId = JSON.parse(sessionStorage.customerID);
            const s3Path = model.user +'/'+ sessionStorage.experimentID + '/' + model.company
            const response = await axios.get(
                "${configure.backendUrl}/listfiles2?instrument=" +
                storedValue
            );
            const data = response.data;
            // data.forEach(m => {
            //     bindData.push(m);
            // })
            setlistedFiles(data);
        } catch (error) {
            console.error("Error fetching upload file:", error);
        }
    };

    useEffect(() => {
        handleUpload();
        if (radioValue==="local"&&
        fileDescriptionRef.current){
            fileDescriptionRef.current.focus();
        }
    }, [radioValue]);

    const buttonStyle = {
        "background-color": "#399dbc",
        "&:hover": { "background-color": "#c4673a" },
    };
    // const fileList = []
    const sectionTitleStyle = {
        padding: "15px",
        color: "#666",
        "font-weight": "300",
        "font-family":
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    };
    const tableHeadRowTextStyle = {
        "padding-left": "0px",
        color: "#666",
        "font-size": "13px",
        "font-weight": "300",
        "font-family":
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    };
    const tableRowStyle = {
        "padding-left": "0px",
        color: "#399dbc",
        "font-size": "13px",
        "font-weight": "300",
        "font-family":
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    };
    const tableStickyHeadRowTextStyle = {
        "background-color": "#dfdfdf",
        "padding-left": "0px",
        color: "#666",
        "font-size": "13px",
        "font-weight": "300",
        "font-family":
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    };
    var count = 0;
    var idToken = JSON.parse(sessionStorage.getItem("idToken"));
    async function upload(file, index) {
        setLoading(true);
        console.log("", getfiles);
        // var file = fileList[0].fileSource.target.files[0]
        console.log(file);
        console.log(formatFileSize(file.size));

        var userPool = JSON.parse(sessionStorage.getItem("customerID"));
        const cognito_id = `cognito-idp.${"us-west-2"}.amazonaws.com/${userPool.pool.userPoolId
            }`;
        const loginDetails = {
            [cognito_id]: idToken.jwtToken,
        };
        // const s3Client = new S3Client({
        //     region: configure.region,
        //     credentials: fromCognitoIdentityPool({
        //         client: new CognitoIdentityClient({ region: configure.region }),
        //         identityPoolId: S3Config.credentials.indentityPoolId,
        //         logins: loginDetails
        //     })
        //     ,
        // }
        // );
        const s3Client = new S3Client({
            region: "us-west-2",
            credentials: fromCognitoIdentityPool({
                client: new CognitoIdentityClient({ region: "us-west-2" }),
                identityPoolId: S3Config.credentials.indentityPoolId,
                logins: loginDetails,
            }),
        });
        var user = JSON.parse(sessionStorage.getItem("userProfile"));
        var customerID = JSON.parse(sessionStorage.getItem("customerID"));
        var experiment_ID = JSON.parse(
            JSON.stringify(sessionStorage.getItem("experimentID"))
        );
        var path =
            customerID.username +
            "/" +
            experiment_ID +
            "/" +
            (user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad "
                ? "BioRad"
                : user.nickname) +
            "/";
        console.log(">>>>>>>>>>>>>>>>PATH", path);
        const target = {
            Bucket: S3Config.endpoint,
            Key: path + file.name,
            Body: file,
        };
        const creds = S3Config.credentials;
        count = 0;
        try {
            const partUpload = new Upload({
                client: s3Client,
                leavePartsOnError: false,
                params: target,
            });

            partUpload.on("httpUploadProgress", (progess) => {
                count = count + 1;
                setProgress(count);
                console.log(progess);
            });

            await partUpload.done();
            getList[index].uploadStatus = "Done";
            setProgress(0);
            setLoading(false);
        } catch (e) {
            console.log(e);
        }
    }

    async function getFileData() {
        var user = JSON.parse(sessionStorage.getItem("userProfile"));
        const experimentFileData = {
            type: "View_Exp",
            Experiment_ID: isDashboard
                ? experimentID
                : JSON.parse(JSON.stringify(sessionStorage.getItem("experimentID"))),
        };
        console.log("experimentFileData", experimentFileData);
        config.headers.Authorization = idToken.jwtToken;
        const response = await fetch(`${configure.backendUrl}/file_data`, {
            method: 'POST',
            body: JSON.stringify(experimentFileData),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.json();
        if(responseData.data && response.status === 200) {
            var customerList = [];
            var bioradList = [];
            var userLists = [];
            var companyLists = [];
            setLoading(true);
            console.log(getfiles);
            uploadFileList = [];
            for (var i = 0; i < Object.keys(getfiles).length; i++) {
                if (
                    getfiles[i].uploadStatus !== "Save" &&
                    getfiles[i].isDelete === false
                ) {
                    var fileSize = formatFileSize(getfiles[i].size);
                    var data = {
                        fileName: getfiles[i].name,
                        size: fileSize,
                        dateStamp: format(new Date(), "dd-MMM-yy kk:mm"),
                        uploadStatus: getfiles[i].uploadStatus,
                        titleName: getfiles[i].titleName,
                        companyName: getfiles[i].companyName,
                    };
                    uploadFileList.push(data);
                }
            }

            if (!isCompany) {
                customerList = uploadFileList;
            }
            if (isCompany) {
                bioradList = uploadFileList;
            }
            setList(uploadFileList);
            setRefresh(false);

            // response function

            for (var j = 0; j < Object.keys(responseData.data).length; j++) {
                if (
                    responseData.data[j]["Company_Name"] !== "Bio-Rad" &&
                    responseData.data[j]["Company_Name"] !== "BioRad" &&
                    responseData.data[j]["Company_Name"] !== "Biorad" &&

                    responseData.data[j].Experiment_ID ===
                    (isDashboard
                        ? experimentID
                        : JSON.parse(
                            JSON.stringify(sessionStorage.getItem("experimentID"))
                        ))
                ) {
                    var data = {
                        fileName: responseData.data[j].File_Name,
                        size: responseData.data[j].Size,
                        dateStamp: responseData.data[j].Create_Date,
                        uploadStatus: responseData.data[j].Upload_Status,
                        titleName: responseData.data[j].File_Title,
                        companyName: responseData.data[j]["Company_Name"],
                        user: responseData.data[j]["User"],
                        fileId: responseData.data[j]["File_ID"],
                        location:responseData.data[j]["Local_location"]
                    };
                    setRowCompanyName(responseData.data[j]["Company_Name"]);
                    userLists.push({"user":responseData.data[j]["User"],"company":responseData.data[j]["Company_Name"]});
                    customerList.push(data);
                }
                if (
                    (responseData.data[j]["Company_Name"] === "Bio-Rad" ||
                        responseData.data[j]["Company_Name"] === "BioRad" ||
                        responseData.data[j]["Company_Name"] === "Biorad") &&
                    responseData.data[j].Experiment_ID ===
                    (isDashboard
                        ? experimentID
                        : JSON.parse(
                            JSON.stringify(sessionStorage.getItem("experimentID"))
                        ))
                ) {
                    var data = {
                        fileName: responseData.data[j].File_Name,
                        size: responseData.data[j].Size,
                        dateStamp: responseData.data[j].Create_Date,
                        uploadStatus: responseData.data[j].Upload_Status,
                        titleName: responseData.data[j].File_Title,
                        companyName: responseData.data[j]["Company_Name"],
                        user: responseData.data[j]["User"],
                        fileId: responseData.data[j]["File_ID"],
                        location:responseData.data[j]["Local_location"]
                    };
                    userLists.push({"user":responseData.data[j]["User"],"company":responseData.data[j]["Company_Name"]});
                    bioradList.push(data);
                }
            }
            if (user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad") {
                setCutomerList(bioradList);
                setBioRadList(customerList);
            } else {
                setCutomerList(customerList);
                setBioRadList(bioradList);
            }
            const filteredUser = [];
            const uniqueNames = userLists.filter((m) => {
                if(filteredUser.length > 0)
                {
                    let lstValue = filteredUser.filter(u => u.user === m.user);
                    if(lstValue.length === 0) {
                        filteredUser.push(m);
                    }
                }  
                else {
                    filteredUser.push(m);
                }
            });
            let bindData = [];
            filteredUser.forEach(user => {
                fetchData(user,bindData);
             })
             setUserList(uniqueNames);

        }
        else {
            navigate('/login');
        }
        
    }

    async function getFileDataWithCloud(cloudFiles) {
        var user = JSON.parse(sessionStorage.getItem("userProfile"));
        const experimentFileData = {
            type: "View_Exp",
            Experiment_ID: isDashboard
                ? experimentID
                : JSON.parse(JSON.stringify(sessionStorage.getItem("experimentID"))),
        };
        console.log("experimentFileData", experimentFileData);
        config.headers.Authorization = idToken.jwtToken;
        const response = await fetch(`${configure.backendUrl}/file_data`, {
            method: 'POST',
            body: JSON.stringify(experimentFileData),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.json();
        if(responseData.data && response.status === 200) {
            var customerList = [];
            var bioradList = [];
            var userLists = [];
            var companyLists = [];
            setLoading(true);
            console.log(getfiles);
            uploadFileList = [];
            for (var i = 0; i < Object.keys(cloudFiles).length; i++) {
                if (
                    cloudFiles[i].uploadStatus !== "Save" &&
                    cloudFiles[i].isDelete === false
                ) {
                    var data = {
                        fileName: cloudFiles[i].fileName,
                        size: "",
                        dateStamp: format(new Date(), "dd-MMM-yy kk:mm"),
                        uploadStatus: cloudFiles[i].uploadStatus,
                        titleName: cloudFiles[i].titleName,
                        companyName: cloudFiles[i].companyName,
                    };
                    uploadFileList.push(data);
                }
            }

            if (!isCompany) {
                customerList = uploadFileList;
            }
            if (isCompany) {
                bioradList = uploadFileList;
            }
            setList(uploadFileList);
            setRefresh(false);

            // response function

            for (var j = 0; j < Object.keys(responseData.data).length; j++) {
                if (
                    responseData.data[j]["Company_Name"] !== "Bio-Rad" &&
                    responseData.data[j]["Company_Name"] !== "BioRad" &&
                    responseData.data[j]["Company_Name"] !== "Biorad" &&

                    responseData.data[j].Experiment_ID ===
                    (isDashboard
                        ? experimentID
                        : JSON.parse(
                            JSON.stringify(sessionStorage.getItem("experimentID"))
                        ))
                ) {
                    var data = {
                        fileName: responseData.data[j].File_Name,
                        size: responseData.data[j].Size,
                        dateStamp: responseData.data[j].Create_Date,
                        uploadStatus: responseData.data[j].Upload_Status,
                        titleName: responseData.data[j].File_Title,
                        companyName: responseData.data[j]["Company_Name"],
                        user: responseData.data[j]["User"],
                        fileId: responseData.data[j]["File_ID"],
                        location:responseData.data[j]["Local_location"]
                    };
                    setRowCompanyName(responseData.data[j]["Company_Name"]);
                    userLists.push({"user":responseData.data[j]["User"],"company":responseData.data[j]["Company_Name"]});
                    customerList.push(data);
                }
                if (
                    (responseData.data[j]["Company_Name"] === "Bio-Rad" ||
                        responseData.data[j]["Company_Name"] === "BioRad" ||
                        responseData.data[j]["Company_Name"] === "Biorad") &&
                    responseData.data[j].Experiment_ID ===
                    (isDashboard
                        ? experimentID
                        : JSON.parse(
                            JSON.stringify(sessionStorage.getItem("experimentID"))
                        ))
                ) {
                    var data = {
                        fileName: responseData.data[j].File_Name,
                        size: responseData.data[j].Size,
                        dateStamp: responseData.data[j].Create_Date,
                        uploadStatus: responseData.data[j].Upload_Status,
                        titleName: responseData.data[j].File_Title,
                        companyName: responseData.data[j]["Company_Name"],
                        user: responseData.data[j]["User"],
                        fileId: responseData.data[j]["File_ID"],
                        location:responseData.data[j]["Local_location"]
                    };
                    userLists.push({"user":responseData.data[j]["User"],"company":responseData.data[j]["Company_Name"]});
                    bioradList.push(data);
                }
            }
            if (user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad") {
                setCutomerList(bioradList);
                setBioRadList(customerList);
            } else {
                setCutomerList(customerList);
                setBioRadList(bioradList);
            }
            const filteredUser = [];
            const uniqueNames = userLists.filter((m) => {
                if(filteredUser.length > 0)
                {
                    let lstValue = filteredUser.filter(u => u.user === m.user);
                    if(lstValue.length === 0) {
                        filteredUser.push(m);
                    }
                }  
                else {
                    filteredUser.push(m);
                }
            });
            let bindData = [];
            filteredUser.forEach(user => {
                fetchData(user,bindData);
             })
             setUserList(uniqueNames);
             setIsDisabled(false);
        }
        else {
            navigate('/login');
        }
        
    }

    const handleDownload = async (filename) => {
        var fileId = filename.fileName;
        var userId = filename.user;
        var companyName = filename.companyName;
        var user = JSON.parse(sessionStorage.getItem("userProfile"));
        var customerID = JSON.parse(sessionStorage.getItem("customerID"));
        var experiment_ID = JSON.parse(
            JSON.stringify(sessionStorage.getItem("experimentID"))
        );
        var path =
            userId +
            "/" +
            experiment_ID +
            "/" +
            (companyName === "Bio-Rad" ? "BioRad"  : companyName) +
            "/";

        var request = {
            name: (filename.location === "Cloud" ? "lfts-test" : "lfts-storage-dev"),
            key: path + fileId,
        };
        const response = await fetch(`${configure.backendUrl}/PreURLGen`, {
            method: 'POST',
            body: JSON.stringify(request),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.text();
        if(responseData && response.status === 200){
            let alink = document.createElement("a");
            alink.href = responseData.replace(" ","");
            alink.click();
        }
        else {
            navigate('/login');
        }
    };

    async function loadFileData() {
        const experimentFileData = {
            type: "View_Exp",
            Experiment_ID: isDashboard
                ? experimentID
                : JSON.parse(JSON.stringify(sessionStorage.getItem("experimentID"))),
        };
        var user = JSON.parse(sessionStorage.getItem("userProfile"));
        config.headers.Authorization = idToken.jwtToken;
        const response = await fetch(`${configure.backendUrl}/file_data`, {
            method: 'POST',
            body: JSON.stringify(experimentFileData),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.json();
        if(responseData.data && response.status === 200){
            var customerList = [];
            var bioradList = [];
            for (var j = 0; j < Object.keys(responseData.data).length; j++) {
                if (
                    responseData.data[j]["Company_Name"] !== "Bio-Rad" &&
                    responseData.data[j]["Company_Name"] !== "BioRad" &&
                    responseData.data[j]["Company_Name"] !== "Biorad" &&
                    responseData.data[j].Experiment_ID ===
                    (isDashboard
                        ? experimentID
                        : JSON.parse(
                            JSON.stringify(sessionStorage.getItem("experimentID"))
                        ))
                ) {
                    var data = {
                        fileName: responseData.data[j].File_Name,
                        size: responseData.data[j].Size,
                        dateStamp: responseData.data[j].Create_Date,
                        uploadStatus: responseData.data[j].Upload_Status,
                        titleName: responseData.data[j].File_Title,
                        companyName: responseData.data[j]["Company_Name"],
                        user: responseData.data[j]["User"],
                        fileId: responseData.data[j]["File_ID"],
                        location:responseData.data[j]["Local_location"]
                    };
                    customerList.push(data);
                }
                if (
                    (responseData.data[j]["Company_Name"] === "BioRad" ||
                        responseData.data[j]["Company_Name"] === "Bio-Rad" ||
                        responseData.data[j]["Company_Name"] === "Biorad") &&
                    responseData.data[j].Experiment_ID ===
                    (isDashboard
                        ? experimentID
                        : JSON.parse(
                            JSON.stringify(sessionStorage.getItem("experimentID"))
                        ))
                ) {
                    var data = {
                        fileName: responseData.data[j].File_Name,
                        size: responseData.data[j].Size,
                        dateStamp: responseData.data[j].Create_Date,
                        uploadStatus: responseData.data[j].Upload_Status,
                        titleName: responseData.data[j].File_Title,
                        companyName: responseData.data[j]["Company_Name"],
                        user: responseData.data[j]["User"],
                        fileId: responseData.data[j]["File_ID"],
                        location:responseData.data[j]["Local_location"]
                    };
                    bioradList.push(data);
                }
            }
            console.log(customerList);
            // setCutomerList(customerList);
            // setBioRadList(bioradList);
            if (user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad") {
                setCutomerList(bioradList);
                setBioRadList(customerList);
            } else {
                setCutomerList(customerList);
                setBioRadList(bioradList);
            }
            setRefresh(true);
        }
        else {
            navigate('/login');
        }
        
    }

    async function dataUpload() {
        var uploadedList = [];
        setIsDisabled(true);
        if(radioValue!=="local" && radioValue!=="")
        {
            for (var i = 0; i < Object.keys(getList).length; i++) {
                if (
                    getList[i].uploadStatus !== "Done" &&
                    getList[i].uploadStatus !== "Save"
                ) {
                    getList[i].uploadStatus = "Uploading";
                    getfiles.filter(
                        (m) => m.titleName === getList[i].titleName
                    )[0].uploadStatus = "Uploading";
                    var file = getfiles.filter(
                        (m) => m.titleName === getList[i].titleName
                    )[0];
                    // getfiles[i].uploadStatus = 'Uploading'
                    handleUpload(getList[i].fileName);
                    getfiles.filter(
                        (m) => m.titleName === getList[i].titleName
                    )[0].uploadStatus = "Save";
                    getList[i].uploadStatus = "Save";
                    uploadedList.push(getList[i]);
                    setUploadList(uploadedList);
                }
    
                if (i === Object.keys(getList).length - 1) {
                    saveFile('Cloud');
                    setFileDescription('');
                }
            }
        }
        else {
            for (var i = 0; i < Object.keys(getList).length; i++) {
                if (
                    getList[i].uploadStatus !== "Done" &&
                    getList[i].uploadStatus !== "Save"
                ) {
                    getList[i].uploadStatus = "Uploading";
                    getfiles.filter(
                        (m) => m.titleName === getList[i].titleName
                    )[0].uploadStatus = "Uploading";
                    var file = getfiles.filter(
                        (m) => m.titleName === getList[i].titleName
                    )[0];
                    // getfiles[i].uploadStatus = 'Uploading'
                    await upload(file, i);
                    getfiles.filter(
                        (m) => m.titleName === getList[i].titleName
                    )[0].uploadStatus = "Save";
                    getList[i].uploadStatus = "Save";
                    uploadedList.push(getList[i]);
                    setUploadList(uploadedList);
                }
    
                if (i === Object.keys(getList).length - 1) {
                    saveFile('Local');
                    setFileDescription('');
                }
            }
        }
        
        //  getFileData()
    }

    async function updateStatus() {
        for (var i = 0; i < Object.keys(getUploadList).length; i++) {
            if (getUploadList[i].uploadStatus === "Done") {
                const experimentFileData = {
                    type: "Update",
                    Experiment_ID: JSON.parse(
                        JSON.stringify(sessionStorage.getItem("experimentID"))
                    ),
                    Upload_Status: "Done",
                };
                getfiles[i].uploadStatus = "Done";
                config.headers.Authorization = idToken.jwtToken;
                const response = await fetch(`${configure.backendUrl}/file_data`, {
                    method: 'POST',
                    body: JSON.stringify(experimentFileData),
                    headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
                });
                const responseData = await response.text();
                if(response.status === 200)
                {

                }
                else {
                    navigate('/login');
                }
                if (i === Object.keys(getUploadList).length - 1) {
                    loadFileData();
                }
            }
        }
    }
    // function deletingFile(event) {
    //     let txt;
    //     console.log("event",event);
    //     if (confirm("Are you sure want to delete!")) {
    //         deleteFile(event.currentTarget.id);
    //         console.log("hii",event.currentTarget.id)
    //     } else {
    //         txt = "Cancel";
    //     }
    // }

    
async function deletingFile(event) {
    const user = JSON.parse(sessionStorage.getItem("userProfile"));
    const clickedFileId = event.currentTarget.id;
    console.log("clickfileid", clickedFileId)
 
    // const clickedFileInfo = getCutomerList.find((item) => item.File_ID === clickedFileId);
    console.log("getlist ",getCutomerList)
    console.log("user", user)
    
    const clickedFileInfo = getCutomerList.find((item) => item.fileId === clickedFileId);
 
    if (!clickedFileInfo) {
        alert("You don't have permission to delete this file.");
        return;
    }
     
    const fileCompanyName = clickedFileInfo.companyName;
     
    if (
        (user.nickname === "Biorad" && fileCompanyName === "Bio-Rad") ||
        (user.nickname === "Biorad" && fileCompanyName === user.nickname)
    )
    {
        if (confirm("Are you sure want to delete!")) {
            await deleteFile(clickedFileId);
        }
    }
    else if 
    (
        (user.nickname !== "Biorad" && fileCompanyName !== "Bio-Rad") ||
        (user.nickname !== "Biorad" && fileCompanyName === user.nickname)
    )
    {
        if (confirm("Are you sure want to delete!")) {
            await deleteFile(clickedFileId);
        }
    }
     else {
        alert("You don't have permission to delete this file.");
    }
}

    async function deleteFile(file_id) {
        const experimentFileData = {
            type: "Delete",
            Experiment_ID: JSON.parse(
                JSON.stringify(sessionStorage.getItem("experimentID"))
            ),
            File_ID: file_id,
        };
        config.headers.Authorization = idToken.jwtToken;
        const response = await fetch(`${configure.backendUrl}/file_data`, {
            method: 'POST',
            body: JSON.stringify(experimentFileData),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.text();
        if (response.status === 200) {
            loadFileData();
        }
        else {
            navigate('/login');
        }
    }

    function clear(index) {
        console.log(index);
        var rowItem = getCutomerList[index];
        var listIndex = getList.findIndex(
            (obj) => obj.titleName === rowItem.titleName
        );
        const removeIndex = fileList.findIndex(
            (object) => object.name === rowItem.fileName
        );
        if (removeIndex !== -1) {
            fileList.splice(removeIndex, 1);
        }
        console.log(fileList);
        getCutomerList.splice(index, 1);
        getList.slice(listIndex, 1);
        setFile(fileList);

        console.log(getList);
        console.log(getCutomerList);
        console.log(getfiles);
        setRefresh(true);
    }

    var storedValue = sessionStorage.getItem("clickedInstrument");

    async function saveFile(loc) {
        var customerID = JSON.parse(sessionStorage.getItem("customerID"));
        for (var i = 0; i < Object.keys(getList).length; i++) {
            if (getList[i].uploadStatus === "Save") {
                var exp_id = moment(new Date()).format("YYMMDDhhmmssSSS");

                const experimentFileData = {
                    type: "Add",
                    File_ID: exp_id.toString(),
                    Experiment_ID: JSON.parse(
                        JSON.stringify(sessionStorage.getItem("experimentID"))
                    ),
                    File_Title: getList[i].titleName,
                    File_Name: getList[i].fileName,
                    Local_location: loc,
                    Cloud_Location: "",
                    Size: getList[i].size,
                    User: customerID.username,
                    Create_Date: getList[i].dateStamp,
                    Update_Date: getList[i].dateStamp,
                    Upload_Status: "Done",
                    Company_Name: companyName,
                    instrument: storedValue,
                };
                config.headers.Authorization = idToken.jwtToken;
                const response = await fetch(`${configure.backendUrl}/file_data`, {
                    method: 'POST',
                    body: JSON.stringify(experimentFileData),
                    headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
                });
                const responseData = await response.text();
                if(response.status === 200)
                {
                    getList[i].uploadStatus = "Done";
                }
                else {
                    navigate('/login');
                }
            }
            if (i === Object.keys(getList).length - 1) {
                setFile([]);
                setList([]);
                fileList = [];
                loadFileData();
            }
        }
        // getFileData();
    }


    async function saveCloudFile(file) {
        var customerID = JSON.parse(sessionStorage.getItem("customerID"));
        for (var i = 0; i < Object.keys(getList).length; i++) {
            if (getList[i].uploadStatus === "Save") {
                var exp_id = moment(new Date()).format("YYMMDDhhmmssSSS");

                const experimentFileData = {
                    type: "Add",
                    File_ID: exp_id.toString(),
                    Experiment_ID: JSON.parse(
                        JSON.stringify(sessionStorage.getItem("experimentID"))
                    ),
                    File_Title: getList[i].titleName,
                    File_Name: file,
                    Local_location: "",
                    Cloud_Location: "",
                    Size: "",
                    User: customerID.username,
                    Create_Date: "",
                    Update_Date: "",
                    Upload_Status: "Done",
                    Company_Name: companyName,
                    instrument: storedValue,
                };
                config.headers.Authorization = idToken.jwtToken;
                const response = await fetch(`${configure.backendUrl}/file_data`, {
                    method: 'POST',
                    body: JSON.stringify(experimentFileData),
                    headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
                });
                const responseData = await response.text();
                if(response.status === 200)
                {
                    getList[i].uploadStatus = "Done";
                }
                else {
                    navigate('/login');
                }
            }
            if (i === Object.keys(getList).length - 1) {
                setFile([]);
                setList([]);
                fileList = [];
                loadFileData();
            }
        }
        // getFileData();
    }

    // function clear(i) {
    //     getList
    // }

    function formatFileSize(bytes, decimalPoint) {
        if (bytes == 0) return "0 Bytes";
        var k = 1000,
            dm = decimalPoint || 2,
            sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    // function createRowData(fileDictionary) {
    //     console.log(inputValue);
    //     for (var i = 0; i < Object.keys(fileDictionary.target.files).length; i++) {
    //         const current = fileDictionary.target.files[i];
    //         const fileDoc = fileDictionary.target.files;
    //         console.log(fileList);
    //         const index =
    //             fileList &&
    //             fileList.findIndex((object) => object.name === current.name);
    //         //don't allow same file to get into table twice
    //         if (index === -1) {
    //             var fileSize = formatFileSize(fileDoc[i]["size"]);
    //             // fileDictionary.target.files[i].titleName = inputValue;
    //             fileDictionary.target.files[i].titleName = fileDescription;
    //             fileDictionary.target.files[i].uploadStatus = "New";
    //             fileDictionary.target.files[i].companyName = companyName;
    //             fileDictionary.target.files[i].isDelete = false;
    //             fileList.push(fileDictionary.target.files[i]);
    //             setFile(fileList);
    //         }
    //     }
    // }


    function createRowData(fileDictionary) {
        console.log(inputValue);
        for (var i = 0; i < Object.keys(fileDictionary.target.files).length; i++) {
            const current = fileDictionary.target.files[i];
            const fileDoc = fileDictionary.target.files;
            console.log(fileList);
            const index =
                fileList &&
                fileList.findIndex((object) => object.name === current.name);
            //don't allow same file to get into table twice
            if (index === -1) {
                var fileSize = formatFileSize(fileDoc[i]["size"]);
                // fileDictionary.target.files[i].titleName = inputValue;
                fileDictionary.target.files[i].titleName = fileDescription;
                fileDictionary.target.files[i].uploadStatus = "New";
                fileDictionary.target.files[i].companyName = companyName;
                fileDictionary.target.files[i].isDelete = false;
                fileList.push(fileDictionary.target.files[i]);
                setFile(fileList);
            }
        }
    }
   

    useEffect(() => {
        if (isLoad) {
            var user = JSON.parse(sessionStorage.getItem("userProfile"));
            setUserProfile(user.email);
            setCompanyName(user.nickname);
            if (user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad") {
                setCompany(true);
            } else {
                setCompany(false);
            }
            console.log(user);
            setLoad(false);
            getFileData();
        }
    }, [isRefresh ? getList : ""]);

    // const fetchData = () => {
    //     setLoading(true);
    //     console.log(getfiles)
    //     uploadFileList = []
    //     for (var i = 0; i < Object.keys(getfiles).length; i++) {
    //         var fileSize = formatFileSize(getfiles[i].size)
    //         var data = {
    //             fileName: getfiles[i].name,
    //             size: fileSize,
    //             dateStamp: format(new Date(), 'dd-MMM-yy kk:mm'),
    //             uploadStatus: getfiles[i].uploadStatus,
    //             titleName: getfiles[i].titleName,
    //             companyName:getfiles[i].companyName
    //         }
    //         uploadFileList.push(data);
    //     }

    //     if(!isCompany)
    //     {
    //         setCutomerList(uploadFileList)
    //     }
    //     if(isCompany)
    //     {
    //         setBioRadList(uploadFileList)
    //     }
    //     setList(uploadFileList);

    //     setRefresh(false);

    // };
    const getCloudFile = (file) => {
        try {
            uploadFileList = [];
            var data = {
                titleName: file.title,
                fileName: file.fileName,
                size: "",
                dateStamp: format(new Date(), "dd-MMM-yy kk:mm"),
                uploadStatus: "New",
                companyName: companyName,
                isDelete: false
            };
            uploadFileList.push(data);
            setFile(uploadFileList);
            getFileDataWithCloud(uploadFileList);
        }
        catch (e) {
            console.log(e);
        }
    }
    const getFile = (file) => {
        try {
            uploadFileList = [];
            createRowData(file);
            var file = file.target.files[0];
            setIsDisabled(false);
            console.log(formatFileSize(file.size));
            var fileSize = formatFileSize(file.size);
            console.log(format(file.lastModifiedDate, "dd-MMM-yy kk:mm"));
            var data = {
                titleName: file.titleName,
                fileName: file.name,
                size: fileSize,
                dateStamp: format(file.lastModifiedDate, "dd-MMM-yy kk:mm"),
                uploadStatus: "New",
                companyName: companyName,
            };
            uploadFileList.push(data);
            setList(uploadFileList);
            setRefresh(true);
            setLoad(true);
            setValue("");
            // setUploadValue("");
            console.log(uploadFileList);
            console.log(getfiles);
        } catch (e) {
            console.log(e);
        }
    };   

    function downloadingFile(event) {
        console.log(event);
        // var txt;
        handleDownload(event);
       
    }

   

    return (
        <div>
            <Box
                width={"90vw"}
                bgcolor={"background.default"}
                color={"text.primary"}
                borderRadius={2}
            >
                <Box borderRadius={2} sx={{ height: 40, bgcolor: "success.main" }}>
                    <Box
                        p={1}
                        display={"flex"}
                        sx={{ alignContent: "center", justifyContent: "space-between" }}
                    >
                        <Typography
                            varient="h6"
                            color="white"
                            textAlign={"left"}
                            sx={{ marginLeft: 1 }}
                        >
                            {isDashboard ? "Attachment History" : "Attachment"}{" "}
                        </Typography>
                        <Button
                            onClick={(e) => setOpen(false)}
                            sx={{ marginLeft: 10, alignContent: "center" }}
                            startIcon={
                                <CloseIcon
                                    sx={{ color: "white", alignContent: "center", marginLeft: 2 }}
                                />
                            }
                        />
                    </Box>
                </Box>
                {!isView.isView && (user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad" || user.nickname === "BIO-RAD" || user.nickname === "BIORAD") && (
                    <Grid item>
                        <Box
                            p={1}
                            display={"flex"}
                            sx={{
                                border: 0,
                                borderColor: "#ccc",
                                marginRight: 2,
                                height: 51,
                                alignContent: "start",
                            }}
                        >

                            <Box
                                p={1}
                                display={"flex"}
                                sx={{ border: "0", flexDirection: "row" }}
                            >
                                <FormControl sx={{ marginLeft: 60 }} >
                                    <RadioGroup
                                        row
                                        aria-label="radio-options"
                                        name="radio-options"
                                        value={radioValue}
                                        onChange={handleRadioChange}
                                        sx={{ width: 300 }}
                                    >
                                        <FormControlLabel
                                            value="local"
                                            control={<Radio />}
                                            label="Local Pc"
                                        />
                                        <FormControlLabel
                                            value="cloud"
                                            control={<Radio />}
                                            label="Bio-Rad Cloud"
                                            sx={{ marginTop: -4.7, marginLeft: 10 }}
                                        />
                                    </RadioGroup>
                                </FormControl>
                                < div sx={{ width: "100%" }} className="div-container">
                                    <TextField

                                        inputRef={fileDescriptionRef}
                                        value={fileDescription}
                                        sx={{ marginLeft: -89, marginTop: 5 }}
                                        onChange={(e) => {
                                            // setValue(e.target.value);
                                            setFileDescription(e.target.value)
                                        }}
                                        placeholder="Enter File Description"
                                        size="small"
                                    ></TextField>
                                    {radioValue === "local" && (
                                        <Button
                                            // disabled={radioValue !== "local"}
                                            variant="contained"
                                            component="label"
                                            onChange={getFile}
                                            sx={{ marginTop: "41px" }}
                                            disabled={!fileDescription}
                                        >
                                            Browse
                                            <input hidden multiple type="file" />
                                        </Button>
                                    )}
                                    {radioValue === "cloud" && (
                                        <FormControl size="small" sx={{ width: 100, marginLeft: 6.5 }}>

                                            <Select
                                                labelId="company-name-label"
                                                id="company-name-select"
                                                placeholder="Location"
                                                size="small"
                                                // disabled={radioValue !== "cloud"} // Disable when radioValue is not 'cloud' 
                                                value={uploadValue}

                                                onChange={handleSelectChange}
                                                // onChange={(e) => {
                                                //     console.log("value))))",uploadValue, e.target.value)                                 
                                                //     //  setUploadValue(e.target.value)

                                                //     setUploadValue(()=> {
                                                //         console.log("hiiii",uploadValue)
                                                //         return e.target.value;
                                                //     });
                                                //     console.log(setUploadValue)

                                                //      handleUpload();
                                                //      }}


                                                // onClick={()=> handleUpload()}
                                                // onChange={getFile}
                                                sx={{ marginTop: 5, marginLeft: -6.5, height: 34 }}
                                            >
                                                {/* <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem> */}
                                                {Object.keys(listedFiles).map((item) => (
                                                    <MenuItem key={item} value={listedFiles[item]}>
                                                        {listedFiles[item]}
                                                    </MenuItem>
                                                ))}

                                            </Select>
                                            {/* <input type="file" onChange={handleFileChange} /> */}
                                        </FormControl>
                                    )}
                                </div>
                              
                            </Box>

                        </Box>
                    </Grid>
                )}


                {!isView.isView && (user.nickname !== "Bio-Rad" && user.nickname !== "BioRad" && user.nickname !== "Biorad" && user.nickname !== "BIO-RAD" && user.nickname !== "BIORAD") && (
                    <Grid item>
                        <Box
                            p={1}
                            display={"flex"}
                            sx={{
                                border: 0,
                                borderColor: "#ccc",
                                marginRight: 2,
                                height: 51,
                                alignContent: "start",
                            }}
                        >

                            <Box
                                p={1}
                                display={"flex"}
                                sx={{ border: "0", flexDirection: "row" }}
                            >

                                < div sx={{ width: "100%" }} className="div-containers">
                                    <TextField
                                        inputRef={fileDescriptionRef}
                                        value={fileDescription}
                                        sx={{ marginLeft: -89, marginTop: 5 }}
                                        onChange={(e) => {
                                            // setValue(e.target.value);
                                            setFileDescription(e.target.value)
                                        }}
                                        placeholder="Enter File Description"
                                        size="small"
                                    ></TextField>
                                    <Button
                                        // disabled={radioValue !== "local"}
                                        variant="contained"
                                        component="label"
                                        onChange={getFile}
                                        sx={{ marginTop: "41px" }}
                                        disabled={!fileDescription}
                                    >
                                        Browse
                                        <input hidden multiple type="file" />
                                    </Button>
                                </div>

                            </Box>

                        </Box>
                    </Grid>
                )}

                <Grid item sx={{ marginLeft: 1 }}>
                    {/* {user.nickname === "Bio-Rad" && ( */}
                    <Box
                        p={1}
                        display={"flex"}
                        sx={{
                            border: 0,
                            borderColor: "#ccc",
                            marginRight: 2,
                            height: 40,
                        }}
                    >
                        {/* <Typography component="h6" fontSize={15}>
                                Browse
                            </Typography> */}


                        {/* <FormControl size="small" sx={{ width: 200, marginLeft: 6.5 }}>
                                <Select
                                    labelId="company-name-label"
                                    id="company-name-select"
                                    placeholder="Location"
                                    size="small"
                                    disabled={radioValue !== "cloud"} // Disable when radioValue is not 'cloud'
                                    value={uploadValue}
                                    onChange={(e) => setUploadValue(e.target.value)}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {listedFiles.map((item) => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <input type="file" onChange={handleFileChange} />
                            </FormControl> */}
                    </Box>
                    {/* )} */}
                </Grid>

                <Grid container spacing={1} sx={{ flexDirection: "column" }}>
                    <Grid item>
                        <Box
                            p={1}
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "10px",
                                marginRight: "10px",
                                justifyContent: "space-between",
                            }}
                        >
                            <Box
                                p={1}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    border: 0,
                                    borderColor: "#ccc",
                                    width: "100%",
                                    height: "40vh",
                                }}
                            >
                                <Typography className="header-style">
                                    {isCompany ? "Bio-Rad" : user.nickname}
                                </Typography>

                                <TableContainer component={Paper}>
                                    <Table stickyHeader size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={tableHeadRowTextStyle}></TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}>Title</TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}>
                                                    File Name
                                                </TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}>Size</TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}>Date</TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getCutomerList.map((row, index) => (
                                                <TableRow key={row.fileName}>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.uploadStatus === "Uploading" && (
                                                            <CircularProgress className="loading" />
                                                        )}
                                                        {row.uploadStatus === "New" && (
                                                            <IconButton aria-label="New">
                                                                <OpenInNewIcon />
                                                            </IconButton>
                                                        )}
                                                        {row.uploadStatus === "Done" && (
                                                            <IconButton className="done" aria-label="Done">
                                                                <DoneIcon />
                                                            </IconButton>
                                                        )}
                                                        {row.uploadStatus === "Error" && (
                                                            <IconButton className="errors" aria-label="Error">
                                                                <HighlightOffIcon />
                                                            </IconButton>
                                                        )}
                                                        {row.uploadStatus === "Save" && (
                                                            <IconButton className="saved" aria-label="Save">
                                                                <SaveIcon />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.titleName}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.fileName}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.size}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.dateStamp}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        <IconButton
                                                            aria-label="download"
                                                            id={
                                                                row.fileName +
                                                                ":" +
                                                                row.user +
                                                                ":" +
                                                                row.companyName
                                                            }
                                                            onClick={()=> downloadingFile(row)}
                                                        >
                                                            <FileDownloadIcon color="primary" />
                                                        </IconButton>
                                                        {(row.uploadStatus === "New" ||
                                                            row.uploadStatus === "Save") && (
                                                                <IconButton
                                                                    aria-label="clear"
                                                                    onClick={(row) => clear(index)}
                                                                >
                                                                    <HighlightOffIcon />
                                                                </IconButton>
                                                            )}
                                                        {row.uploadStatus === "Done" && (
                                                            <IconButton
                                                                aria-label="delete"
                                                                id={row.fileId}
                                                                onClick={deletingFile}
                                                            >
                                                                <DeleteIcon sx={{ color: "red" }} />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {/* <LinearProgress sx={{ width: '100%', top: '5px' }} variant="determinate" value={getCompany === "Customer" ? progress : 0} /> */}
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <Divider
                                    orientation="vertical"
                                    sx={{ bgcolor: "#bdbdbd", borderBottomWidth: 1 }}
                                />
                            </Box>
                            <Box
                                p={1}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    border: 0,
                                    borderColor: "#ccc",
                                    width: "100%",
                                    height: "40vh",
                                }}
                            >
                                <Typography className="header-style">
                                    {isCompany ? rowCompanyName : "Bio-Rad"}
                                </Typography>
                                <TableContainer component={Paper}>
                                    <Table stickyHeader size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={tableHeadRowTextStyle}></TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}>Title</TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}>
                                                    File Name
                                                </TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}>Size</TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}>Date</TableCell>
                                                <TableCell sx={tableHeadRowTextStyle}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getBioRadList.map((row) => (
                                                // { console.log(".................getBioRadList", getBioRadList) }
                                                < TableRow key={row.fileName} >
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.uploadStatus === "Uploading" && (
                                                            <CircularProgressWithLabel
                                                                className="loading"
                                                                value={progress}
                                                            />
                                                        )}
                                                        {row.uploadStatus === "New" && (
                                                            <IconButton aria-label="New">
                                                                <OpenInNewIcon />
                                                            </IconButton>
                                                        )}
                                                        {row.uploadStatus === "Done" && (
                                                            <IconButton className="done" aria-label="Done">
                                                                <DoneIcon />
                                                            </IconButton>
                                                        )}
                                                        {row.uploadStatus === "Error" && (
                                                            <IconButton className="errors" aria-label="Error">
                                                                <HighlightOffIcon />
                                                            </IconButton>
                                                        )}
                                                        {row.uploadStatus === "Save" && (
                                                            <IconButton className="saved" aria-label="Save">
                                                                <SaveIcon />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.titleName}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.fileName}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.size}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        {row.dateStamp}
                                                    </TableCell>
                                                    <TableCell align="left" sx={tableRowStyle}>
                                                        <IconButton
                                                            aria-label="download"
                                                            id={
                                                                row.fileName +
                                                                ":" +
                                                                row.user +
                                                                ":" +
                                                                row.companyName
                                                            }
                                                            onClick={()=> downloadingFile(row)}
                                                        >
                                                            <FileDownloadIcon color="primary" />
                                                        </IconButton>
                                                        {(row.uploadStatus === "New" ||
                                                            row.uploadStatus === "Save") && (
                                                                <IconButton
                                                                    aria-label="clear"
                                                                    onClick={(row) => clear(index)}
                                                                >
                                                                    <HighlightOffIcon />
                                                                </IconButton>
                                                            )}
                                                        {row.uploadStatus === "Done" && (
                                                            <IconButton
                                                                aria-label="delete"
                                                                id={row.fileId}
                                                                onClick={deletingFile}
                                                            >
                                                                <DeleteIcon sx={{ color: "red" }} />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {/* <LinearProgress sx={{ width: '100%', top: '5px' }} variant="determinate" value={getCompany === "Bio-Rad" ? progress : 0} /> */}
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: 3,
                                marginRight: 3,
                            }}
                        >
                            <Divider
                                orientation="horizontal"
                                sx={{ bgcolor: "#bdbdbd", borderBottomWidth: 1 }}
                            />
                        </Box>
                    </Grid>
                </Grid>
                {!isView.isView && (
                    <Grid item>
                        <Box p={1} display={"flex"} sx={{ justifyContent: "flex-end" }}>
                            <Box
                                p={1}
                                display={"flex"}
                                sx={{ width: 225, justifyContent: "space-between" }}
                            >
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => setOpen(false)}
                                    sx={{ width: 100 }}
                                >
                                    Ok
                                </Button>
                                <Button
                                    size="small"
                                    variant="contained"
                                    disabled={isDisabled}
                                    color="success"
                                    onClick={dataUpload}
                                    sx={{ width: 100 }}
                                >
                                    Upload
                                </Button>
                                {/* <Button size="small" variant="contained" onClick={} sx={{ width: 100 }}>Submit</Button> */}
                            </Box>
                        </Box>
                    </Grid>
                )}
            </Box>

            <>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseAlert}
          severity="error"
        >
          {alertMessage}
        </MuiAlert>
      </Snackbar>
 
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={6000}
        onClose={handleCloseSuccessAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSuccessAlert}
          severity="success"
        >
          {successMessage}
        </MuiAlert>
      </Snackbar>
    </>

        </div >

        
    );
}
